export function Mascot({ size = 56 }: { size?: number }) {
  return (
    <div
      className="relative [animation:ss-mascot-glow_4s_ease-in-out_infinite]"
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <defs>
          <linearGradient id="ss-paper-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--color-accent-hover)" />
            <stop offset="100%" stopColor="var(--color-accent-deep)" />
          </linearGradient>
        </defs>
        <path
          d="M4 28 L60 6 L48 58 L34 38 L4 28 Z"
          fill="url(#ss-paper-grad)"
          stroke="var(--color-accent)"
          strokeWidth="1"
          strokeLinejoin="round"
        />
        <path
          d="M4 28 L34 38 L40 28 Z"
          fill="var(--color-accent-deep)"
          opacity="0.6"
        />
        <path
          d="M34 38 L48 58 L40 28 Z"
          fill="var(--color-accent-deep)"
          opacity="0.4"
        />
      </svg>
    </div>
  );
}
